import React from "react";
import "./style.css";
import classNames from "classnames";
export default function TextInputV2(props) {
    const { value, onChange, elementId, label, placeholder, resizable = false, fullWidth = false, customWidth, } = props;
    const elementuId = elementId + crypto.randomUUID();
    return (React.createElement("div", { className: classNames("text-input-v2", {
            "text-input-v2--slim": props.variant === "slim",
            "text-input-v2-resizable": resizable,
            "text-input-v2--full-width": fullWidth,
        }) },
        label && React.createElement("label", { htmlFor: elementuId }, label),
        React.createElement("input", { type: "text", value: value, id: elementuId, placeholder: placeholder, onChange: (event) => onChange(event.target.value), style: customWidth ? { width: customWidth } : undefined })));
}
